import request from '@/plugin/axios'

export function ListVariables (data) {
  return request({
    url: '/variable/index',
    method: 'get',
    params: data
  })
}

export function ViewVariable (id) {
  return request({
    url: '/variable/view?id=' + id,
    method: 'get'
  })
}

export function CreateVariable (data) {
  return request({
    url: '/variable/create',
    method: 'post',
    data
  })
}

export function UpdateVariable (data) {
  return request({
    url: '/variable/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DeleteVariable (id) {
  return request({
    url: '/variable/delete?id=' + id,
    method: 'delete'
  })
}
